import * as THREE from "three";

export default function setupShadowPlane(threeViewer: any, product: THREE.Object3D): void {
    if (threeViewer.shadow) {
        threeViewer.scene.remove(threeViewer.shadow);
        threeViewer.shadow.geometry.dispose();
        threeViewer.shadow.material.dispose();
        threeViewer.shadow = null;
    }

    const textureLoader = new THREE.TextureLoader();
    const shadowTexture = textureLoader.load('/assets/images/textures/shadowplane.jpg');
    shadowTexture.colorSpace = THREE.NoColorSpace;
    shadowTexture.wrapS = shadowTexture.wrapT = THREE.ClampToEdgeWrapping;

    const shadow = new THREE.Mesh(
        new THREE.PlaneGeometry(1, 1),
        new THREE.MeshBasicMaterial({
            color: 0x000000,
            alphaMap: shadowTexture,
            transparent: true,
            opacity: 0.7,
            depthWrite: false,
        })
    );
    shadow.rotation.x = -Math.PI / 2;
    shadow.material.toneMapped = false;



    // Fit shadow to product size
    const box = new THREE.Box3().setFromObject(product);
    const size = box.getSize(new THREE.Vector3());
    const diameter = Math.max(size.x, size.z);

    shadow.scale.set(diameter * 4.5, diameter * 4.5, 1);
    shadow.position.set(0, box.min.y - 0.001, 0);


    //threeViewer.overlayScene.add(shadow)
    threeViewer.scene.add(shadow);


    threeViewer.shadow = shadow;


}